// Shared by the Market Shop, Visitor Parking and Package Room mini-app flows, all of which
// authenticate via a token appended to the URL hash (e.g. `#/market-shop?token=XXX`).
//
// Deliberately re-reads `location.hash` on every call rather than caching/stripping it: for
// stationary devices (Package Room terminals, on-site Market Shop kiosks) the pasted-in URL
// *is* the persistent credential store, and these devices reload themselves (stale-client
// detection, manual reload) expecting the token to still be there afterwards. Hoisting the
// token into memory and stripping it from the URL survives within a page session but is wiped
// by that reload, permanently breaking the device. See EL-13974.
export const getTokenFromURL = (): string | null => {
  const hash = window.location.hash
  const hashParams = hash.split('?')[1]

  if (!hashParams) return null

  const urlParams = new URLSearchParams(hashParams)
  return urlParams.get('token')
}
